/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class AuthProviderEntity extends Entity {
  domain: string | null = null;
  id: string = '';
  organizationId: string | null = null;
  type: string | null = null;
  url: string | null = null;
  static override key = 'AuthProvider';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'AuthProvider' in input
    ) {
      const { AuthProvider: wrapped, ...rest } = input as {
        AuthProvider: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}